import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { PbLong, PbULong } from "./pb-long";
import { varint32write, varint64write } from "./goog-varint";
import { assertFloat32, assertInt32, assertUInt32 } from "./assert";
var defaultsWrite = {
  writeUnknownFields: true,
  writerFactory: function writerFactory() {
    return new BinaryWriter();
  }
};
/**
 * Make options for writing binary data form partial options.
 */

export function binaryWriteOptions(options) {
  return options ? Object.assign(Object.assign({}, defaultsWrite), options) : defaultsWrite;
}
export var BinaryWriter = /*#__PURE__*/function () {
  function BinaryWriter(textEncoder) {
    _classCallCheck(this, BinaryWriter);

    /**
     * Previous fork states.
     */
    this.stack = [];
    this.textEncoder = textEncoder !== null && textEncoder !== void 0 ? textEncoder : new TextEncoder();
    this.chunks = [];
    this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */


  _createClass(BinaryWriter, [{
    key: "finish",
    value: function finish() {
      this.chunks.push(new Uint8Array(this.buf)); // flush the buffer

      var len = 0;

      for (var i = 0; i < this.chunks.length; i++) {
        len += this.chunks[i].length;
      }

      var bytes = new Uint8Array(len);
      var offset = 0;

      for (var _i = 0; _i < this.chunks.length; _i++) {
        bytes.set(this.chunks[_i], offset);
        offset += this.chunks[_i].length;
      }

      this.chunks = [];
      return bytes;
    }
    /**
     * Start a new fork for length-delimited data like a message
     * or a packed repeated field.
     *
     * Must be joined later with `join()`.
     */

  }, {
    key: "fork",
    value: function fork() {
      this.stack.push({
        chunks: this.chunks,
        buf: this.buf
      });
      this.chunks = [];
      this.buf = [];
      return this;
    }
    /**
     * Join the last fork. Write its length and bytes, then
     * return to the previous state.
     */

  }, {
    key: "join",
    value: function join() {
      // get chunk of fork
      var chunk = this.finish(); // restore previous state

      var prev = this.stack.pop();
      if (!prev) throw new Error('invalid state, fork stack empty');
      this.chunks = prev.chunks;
      this.buf = prev.buf; // write length of chunk as varint

      this.uint32(chunk.byteLength);
      return this.raw(chunk);
    }
    /**
     * Writes a tag (field number and wire type).
     *
     * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
     *
     * Generated code should compute the tag ahead of time and call `uint32()`.
     */

  }, {
    key: "tag",
    value: function tag(fieldNo, type) {
      return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
     * Write a chunk of raw bytes.
     */

  }, {
    key: "raw",
    value: function raw(chunk) {
      if (this.buf.length) {
        this.chunks.push(new Uint8Array(this.buf));
        this.buf = [];
      }

      this.chunks.push(chunk);
      return this;
    }
    /**
     * Write a `uint32` value, an unsigned 32 bit varint.
     */

  }, {
    key: "uint32",
    value: function uint32(value) {
      assertUInt32(value); // write value as varint 32, inlined for speed

      while (value > 0x7f) {
        this.buf.push(value & 0x7f | 0x80);
        value = value >>> 7;
      }

      this.buf.push(value);
      return this;
    }
    /**
     * Write a `int32` value, a signed 32 bit varint.
     */

  }, {
    key: "int32",
    value: function int32(value) {
      assertInt32(value);
      varint32write(value, this.buf);
      return this;
    }
    /**
     * Write a `bool` value, a variant.
     */

  }, {
    key: "bool",
    value: function bool(value) {
      this.buf.push(value ? 1 : 0);
      return this;
    }
    /**
     * Write a `bytes` value, length-delimited arbitrary data.
     */

  }, {
    key: "bytes",
    value: function bytes(value) {
      this.uint32(value.byteLength); // write length of chunk as varint

      return this.raw(value);
    }
    /**
     * Write a `string` value, length-delimited data converted to UTF-8 text.
     */

  }, {
    key: "string",
    value: function string(value) {
      var chunk = this.textEncoder.encode(value);
      this.uint32(chunk.byteLength); // write length of chunk as varint

      return this.raw(chunk);
    }
    /**
     * Write a `float` value, 32-bit floating point number.
     */

  }, {
    key: "float",
    value: function float(value) {
      assertFloat32(value);
      var chunk = new Uint8Array(4);
      new DataView(chunk.buffer).setFloat32(0, value, true);
      return this.raw(chunk);
    }
    /**
     * Write a `double` value, a 64-bit floating point number.
     */

  }, {
    key: "double",
    value: function double(value) {
      var chunk = new Uint8Array(8);
      new DataView(chunk.buffer).setFloat64(0, value, true);
      return this.raw(chunk);
    }
    /**
     * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
     */

  }, {
    key: "fixed32",
    value: function fixed32(value) {
      assertUInt32(value);
      var chunk = new Uint8Array(4);
      new DataView(chunk.buffer).setUint32(0, value, true);
      return this.raw(chunk);
    }
    /**
     * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
     */

  }, {
    key: "sfixed32",
    value: function sfixed32(value) {
      assertInt32(value);
      var chunk = new Uint8Array(4);
      new DataView(chunk.buffer).setInt32(0, value, true);
      return this.raw(chunk);
    }
    /**
     * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
     */

  }, {
    key: "sint32",
    value: function sint32(value) {
      assertInt32(value); // zigzag encode

      value = (value << 1 ^ value >> 31) >>> 0;
      varint32write(value, this.buf);
      return this;
    }
    /**
     * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
     */

  }, {
    key: "sfixed64",
    value: function sfixed64(value) {
      var chunk = new Uint8Array(8);
      var view = new DataView(chunk.buffer);
      var long = PbLong.from(value);
      view.setInt32(0, long.lo, true);
      view.setInt32(4, long.hi, true);
      return this.raw(chunk);
    }
    /**
     * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
     */

  }, {
    key: "fixed64",
    value: function fixed64(value) {
      var chunk = new Uint8Array(8);
      var view = new DataView(chunk.buffer);
      var long = PbULong.from(value);
      view.setInt32(0, long.lo, true);
      view.setInt32(4, long.hi, true);
      return this.raw(chunk);
    }
    /**
     * Write a `int64` value, a signed 64-bit varint.
     */

  }, {
    key: "int64",
    value: function int64(value) {
      var long = PbLong.from(value);
      varint64write(long.lo, long.hi, this.buf);
      return this;
    }
    /**
     * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
     */

  }, {
    key: "sint64",
    value: function sint64(value) {
      var long = PbLong.from(value),
          // zigzag encode
      sign = long.hi >> 31,
          lo = long.lo << 1 ^ sign,
          hi = (long.hi << 1 | long.lo >>> 31) ^ sign;
      varint64write(lo, hi, this.buf);
      return this;
    }
    /**
     * Write a `uint64` value, an unsigned 64-bit varint.
     */

  }, {
    key: "uint64",
    value: function uint64(value) {
      var long = PbULong.from(value);
      varint64write(long.lo, long.hi, this.buf);
      return this;
    }
  }]);

  return BinaryWriter;
}();